import { render, staticRenderFns } from "./CustomerOrderList.vue?vue&type=template&id=35aa3a82"
import script from "./CustomerOrderList.vue?vue&type=script&lang=js"
export * from "./CustomerOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports